import { redirect } from 'react-router-dom';

import * as Yup from 'yup';

import { StorageKey } from '../enum/StorageKey';

import { dateHasExpired } from './date';

import { getItemFromSessionStorage } from './session-storage';
import { initAxios } from '../service/axios';

export const hashPassword = (password: string): string => password;

export const validationSchema = Yup.object().shape({
  username: Yup.string().trim().required('Username is required!'),
  password: Yup.string().trim().required('Password is required!'),
});

export const isLoggedIn = () => {
  const accessToken = getItemFromSessionStorage(StorageKey.ACCESS_TOKEN)?.trim();
  const expiryDate = getItemFromSessionStorage(StorageKey.EXPIRY_DATE)?.trim();

  return !!accessToken && !!expiryDate && !dateHasExpired(expiryDate);
};

export const loginLoader = () => {
  if (isLoggedIn()) {
    return redirect('/');
  }

  return null;
};

export const loadHealthMonitorTokens = (): boolean => {
  const storedAccessToken = getItemFromSessionStorage(StorageKey.ACCESS_TOKEN_HM)?.trim();
  const storedRefreshToken = getItemFromSessionStorage(StorageKey.REFRESH_TOKEN_HM)?.trim();

  if (storedAccessToken && storedRefreshToken) {
    initAxios(storedAccessToken, storedRefreshToken);
    return true;
  }

  return false;
};
